/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
// Core
import { ControlComponent } from '../../core/component/control.component';
// JQX Widget
import { jqxPopoverComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxpopover';

/**
 * Popover
 */

export class NgcPopoverComponent extends ControlComponent {
     arrowOffsetValue: any;
     animationOpenDelay: any;
     animationCloseDelay: any;
     autoClose: any;
     animationType: any;
     initContent: any;
     isModal: any;
     offset: any;
     position: any;
     rtl: any;
     selector: any;
     showArrow: any;
     showCloseButton: any;
     title: any;
     theme: any;
     width: any;
     height: any;
     autoCreate: boolean = true;

     jqxPopover: jqxPopoverComponent;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    open() {
        this.jqxPopover.open();
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-popover',
    template: `<jqxPopover #jqxPopover
                [arrowOffsetValue] = "arrowOffsetValue"
                [animationOpenDelay] = "animationOpenDelay"
                [animationCloseDelay] = "animationCloseDelay"
                [autoClose] = "autoClose"
                [animationType] = "animationType"
                [initContent] = "initContent"
                [isModal] = "isModal"
                [offset] = "offset"
                [position] = "position"
                [rtl] = "rtl"
                [selector] = "selector"
                [showArrow] = "showArrow"
                [showCloseButton] = "showCloseButton"
                [title] = "title"
                [theme] = "theme"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxPopover>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'arrowOffsetValue': [{ type: Input, args: ['arrowOffsetValue', ] },],
'animationOpenDelay': [{ type: Input, args: ['animationOpenDelay', ] },],
'animationCloseDelay': [{ type: Input, args: ['animationCloseDelay', ] },],
'autoClose': [{ type: Input, args: ['autoClose', ] },],
'animationType': [{ type: Input, args: ['animationType', ] },],
'initContent': [{ type: Input, args: ['initContent', ] },],
'isModal': [{ type: Input, args: ['isModal', ] },],
'offset': [{ type: Input, args: ['offset', ] },],
'position': [{ type: Input, args: ['position', ] },],
'rtl': [{ type: Input, args: ['rtl', ] },],
'selector': [{ type: Input, args: ['selector', ] },],
'showArrow': [{ type: Input, args: ['showArrow', ] },],
'showCloseButton': [{ type: Input, args: ['showCloseButton', ] },],
'title': [{ type: Input, args: ['title', ] },],
'theme': [{ type: Input, args: ['theme', ] },],
'width': [{ type: Input, args: ['width', ] },],
'height': [{ type: Input, args: ['height', ] },],
'autoCreate': [{ type: Input, args: ['auto-create', ] },],
'jqxPopover': [{ type: ViewChild, args: ['jqxPopover', ] },],
};
}

/**
 * Popover Module
 */

export class NgcPopoverModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    exports: [NgcPopoverComponent],
    declarations: [NgcPopoverComponent, jqxPopoverComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
